import React from 'react';

import './ModalHeading.less';

export default function ModalHeading({children}) {
    return <h2 className="ModalHeading margin-bottom-0">{children}</h2>;
}
